var React = require('react');

function LargeStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.675 38.8437L60.5 6.77865L76.325 38.8437L78.5838 40.4848L113.97 45.6267L88.3643 70.5858L87.5015 73.2412L93.5461 108.484L61.896 91.8446H59.104L27.4539 108.484L33.4985 73.2412L32.6358 70.5858L7.03032 45.6266L42.4162 40.4848L44.675 38.8437Z","stroke":"#003366","strokeWidth":"6","strokeLinejoin":"bevel"}));
}

LargeStar.defaultProps = {"width":"121","height":"114","viewBox":"0 0 121 114","fill":"none"};

module.exports = LargeStar;

LargeStar.default = LargeStar;
